/*
  assets/gtender-partner-dashboard.js — GTENDER-PARTNER-WORKSPACE-01
  Owner: verified Partner organisation workspace projection on /pages/gtender-partner-dashboard.
  Identity owner: window.LittleGWebSession. Legacy private workflow stays dormant until native authorization is verified.
  Authorization owner: GTender backend Partner status / organisation membership / action permissions.
  Note: organisation profile, team, assignments, collaboration and professional handoff.
  No browser-issued Partner access and no formal government tender submission.
*/
(function partnerWorkspaceRuntime(window, document) {
  'use strict';

  var VERSION = 'gtender-partner-workspace-01';
  var ROOT_SELECTOR = '[data-gtender-partner-dashboard]';
  var GLOBAL_KEY = '__GTENDER_PARTNER_WORKSPACE_RUNTIME__';
  var stateByRoot = new WeakMap();
  var COPY = {
    en: {
      ready: 'Verified organisation workspace ready.',
      unavailable: 'Partner access could not be verified right now.',
      wrongRole:
        'You are signed in as a general member. Apply for Partner provider access to use this workspace.',
      approval: 'Approved organisation membership is required.',
      loading: 'Loading organisation workspace…',
      loadFailed: 'Some workspace information could not be loaded.',
      noTeam: 'No organisation members are available.',
      noAssignments: 'No opportunities are assigned yet.',
      noHandoffs: 'No professional handoffs yet.',
      verified: 'Verified',
      unverified: 'Not verified',
      saved: 'Saved.',
      assigned: 'Opportunity assigned.',
      handoffCreated: 'Professional handoff created.',
      collaborationLoaded: 'Shared workspace loaded.',
      collaborationEmpty: 'No shared workspace exists for this opportunity yet.',
      requestFailed: 'The request could not be completed.',
      evidence: 'Evidence',
      assignments: 'Assignments',
      stage: 'Stage',
      project: 'Project',
      noCapabilities: 'No capability information provided.',
    },
    zh: {
      ready: '已核實的機構工作區已開放。',
      unavailable: '暫時無法確認合作夥伴權限。',
      wrongRole: '你目前為一般會員。可申請開通 Partner 合作夥伴資格，或返回公開招標大廳。',
      approval: '需要已批准的機構成員資格。',
      loading: '正在載入機構工作區…',
      loadFailed: '部分工作區資料暫時無法載入。',
      noTeam: '目前沒有可顯示的機構成員。',
      noAssignments: '目前沒有已分配的機會。',
      noHandoffs: '目前沒有專業交接。',
      verified: '已核實',
      unverified: '未核實',
      saved: '已儲存。',
      assigned: '已分配機會。',
      handoffCreated: '已建立專業交接。',
      collaborationLoaded: '已載入共享工作。',
      collaborationEmpty: '此機會尚未建立共享工作。',
      requestFailed: '暫時無法完成這項操作。',
      evidence: '資料',
      assignments: '分工',
      stage: '階段',
      project: '項目',
      noCapabilities: '尚未提供服務能力資料。',
    },
  };

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }
  function list(scope, selector) {
    return scope && scope.querySelectorAll
      ? Array.prototype.slice.call(scope.querySelectorAll(selector))
      : [];
  }
  function locale(state) {
    return state.root.getAttribute('data-locale') === 'zh' ? 'zh' : 'en';
  }

  function words(state, key) {
    return COPY[locale(state)][key] || COPY.en[key] || key;
  }
  function dataOf(payload) {
    return payload && payload.data && typeof payload.data === 'object' ? payload.data : {};
  }
  function itemsOf(payload) {
    var data = dataOf(payload);
    return Array.isArray(data.items) ? data.items : [];
  }
  function lastFour(value) {
    var text = clean(value);
    return text ? text.slice(-4) : '—';
  }

  function endpoint(root, name) {
    var raw = clean(root.getAttribute(name));
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      return url.origin === window.location.origin ? url.toString() : '';
    } catch (_error) {
      return '';
    }
  }

  async function requestJson(url, options) {
    if (!url) return { ok: false, status: 0, payload: {}, error: 'missing_endpoint' };
    try {
      var init = Object.assign(
        { credentials: 'same-origin', headers: { Accept: 'application/json' } },
        options || {}
      );
      if (init.body && typeof init.body !== 'string') {
        init.body = JSON.stringify(init.body);
        init.headers = Object.assign({}, init.headers, { 'Content-Type': 'application/json' });
      }
      var response = await fetch(url, init);
      var payload = await response.json().catch(function () {
        return {};
      });
      return {
        ok: response.ok && payload && payload.success !== false,
        status: response.status,
        payload: payload,
        error: clean(payload && payload.error && (payload.error.message || payload.error.code)),
      };
    } catch (_error) {
      return { ok: false, status: 0, payload: {}, error: 'network_error' };
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function text(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = clean(value) || '—';
  }

  function showAccess(state, name, message) {
    list(state.root, '[data-gpd-access-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-gpd-access-panel') !== name;
    });
    var workspace = state.root.querySelector('[data-gpd-workspace]');
    if (workspace) workspace.hidden = name !== 'ready';
    state.root.setAttribute('data-gpd-access', name);
    var partnerNav = state.root.querySelector('[data-gpd-approved-nav]');
    if (partnerNav) partnerNav.hidden = name !== 'ready';
    if (message) text(state.root, '[data-gpd-denied-copy]', message);
    var apply = state.root.querySelector('[data-gpd-apply]');
    if (apply)
      apply.hidden = !(
        name === 'denied' &&
        state.access &&
        state.access.authenticated === true &&
        (state.access.role_verified !== true || state.access.approved !== true)
      );
  }

  function setWorkspaceStatus(state, message) {
    text(state.root, '[data-gpd-workspace-status]', message);
  }

  function setStat(root, name, value) {
    var node = root.querySelector('[data-gpd-stat="' + name + '"]');
    if (node) node.textContent = String(Number(value) || 0);
  }

  function permissionSet(state) {
    var access = state.access || {};
    if (clean(access.membership_role) === 'owner')
      return new Set([
        'view_workspace',
        'manage_team',
        'assign_opportunity',
        'edit_evidence',
        'manage_handoff',
      ]);
    var current = state.team.find(function (member) {
      return clean(member.customer_id) === clean(access.customer_id);
    });
    return new Set(
      current && Array.isArray(current.permissions) ? current.permissions.map(clean) : []
    );
  }

  function hasPermission(state, permission) {
    return permissionSet(state).has(permission);
  }

  function capabilityLabels(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return [];
    var output = [];
    Object.keys(value).forEach(function (key) {
      var item = value[key];
      if (item === true) output.push(key);
      else if (typeof item === 'string' && clean(item)) output.push(clean(item));
      else if (item && typeof item === 'object' && !Array.isArray(item))
        output.push(clean(item.label || item.id || key));
    });
    return Array.from(new Set(output.filter(Boolean)));
  }

  function renderOrganisation(state) {
    var profile = state.organisation || {};
    var verification =
      profile.verification && typeof profile.verification === 'object' ? profile.verification : {};
    text(
      state.root,
      '[data-gpd-organisation-name]',
      profile.name || state.access.organisation_name || 'Partner organisation'
    );
    text(state.root, '[data-gpd-org-legal]', profile.legal_name || profile.name);
    text(state.root, '[data-gpd-org-region]', profile.region);
    var website = state.root.querySelector('[data-gpd-org-website]');
    if (website) {
      website.replaceChildren();
      var rawWebsite = clean(profile.website);
      if (rawWebsite) {
        try {
          var url = new URL(rawWebsite);
          if (url.protocol === 'https:') {
            var link = element('a', '', url.hostname);
            link.href = url.toString();
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            website.appendChild(link);
          } else website.textContent = rawWebsite;
        } catch (_error) {
          website.textContent = rawWebsite;
        }
      } else website.textContent = '—';
    }
    text(state.root, '[data-gpd-membership-role]', state.access.membership_role);
    const verificationLabel =
      verification.verified === true
        ? locale(state) === 'zh'
          ? '核實標記：是（範圍未顯示）'
          : 'Verification flag: Yes (scope not shown)'
        : verification.verified === false
          ? words(state, 'unverified')
          : locale(state) === 'zh'
            ? '核實狀態不明'
            : 'Verification unknown';

    text(state.root, '[data-gpd-verification]', verificationLabel);
    var caps = state.root.querySelector('[data-gpd-capabilities]');
    if (caps) {
      caps.replaceChildren();
      var labels = capabilityLabels(profile.capabilities);
      if (!labels.length)
        caps.appendChild(element('span', 'gpd-empty', words(state, 'noCapabilities')));
      else
        labels.forEach(function (label) {
          caps.appendChild(element('span', 'gpd-capability', label));
        });
    }
  }

  function renderTeam(state) {
    var container = state.root.querySelector('[data-gpd-team-list]');
    var select = state.root.querySelector('[data-gpd-assignee-select]');
    if (container) container.replaceChildren();
    if (select) select.replaceChildren();
    if (!state.team.length) {
      if (container) container.appendChild(element('div', 'gpd-empty', words(state, 'noTeam')));
      return;
    }
    state.team.forEach(function (member, index) {
      if (container) {
        var row = element('article', 'gpd-row');
        row.appendChild(
          element('strong', '', (locale(state) === 'zh' ? '成員 ' : 'Member ') + String(index + 1))
        );
        var meta = element('div', 'gpd-row-meta');
        meta.appendChild(element('span', '', clean(member.membership_role) || 'member'));
        meta.appendChild(element('span', '', clean(member.status) || 'active'));
        if (Array.isArray(member.permissions) && member.permissions.length)
          meta.appendChild(element('span', '', member.permissions.join(' · ')));
        row.appendChild(meta);
        container.appendChild(row);
      }
      if (select && clean(member.status) === 'active') {
        var option = document.createElement('option');
        option.value = clean(member.customer_id);
        option.textContent =
          (clean(member.membership_role) || 'member') + ' · …' + lastFour(member.customer_id);
        select.appendChild(option);
      }
    });
  }

  function renderAssignments(state) {
    var container = state.root.querySelector('[data-gpd-assignment-list]');
    if (!container) return;
    container.replaceChildren();
    if (!state.assignments.length) {
      container.appendChild(element('div', 'gpd-empty', words(state, 'noAssignments')));
      return;
    }
    state.assignments.forEach(function (item) {
      var row = element('article', 'gpd-row');
      row.appendChild(element('strong', '', clean(item.tender_id) || 'Opportunity'));
      var meta = element('div', 'gpd-row-meta');
      meta.appendChild(element('span', '', clean(item.status) || 'active'));
      meta.appendChild(
        element(
          'span',
          '',
          (locale(state) === 'zh' ? '負責成員 …' : 'Owner …') + lastFour(item.assignee_customer_id)
        )
      );
      row.appendChild(meta);
      container.appendChild(row);
    });
  }

  function renderHandoffs(state) {
    var container = state.root.querySelector('[data-gpd-handoff-list]');
    if (!container) return;
    container.replaceChildren();
    if (!state.handoffs.length) {
      container.appendChild(element('div', 'gpd-empty', words(state, 'noHandoffs')));
      return;
    }
    state.handoffs.forEach(function (item) {
      var row = element('article', 'gpd-row');
      row.appendChild(
        element('strong', '', clean(item.client_name || item.client_reference) || 'Client handoff')
      );
      var meta = element('div', 'gpd-row-meta');
      meta.appendChild(element('span', '', clean(item.tender_id) || '—'));
      meta.appendChild(element('span', '', clean(item.status) || 'proposed'));
      if (Number.isFinite(Number(item.match_score)))
        meta.appendChild(element('span', '', 'Match ' + Math.round(Number(item.match_score))));
      row.appendChild(meta);
      container.appendChild(row);
    });
  }

  function updateActionVisibility(state) {
    var assignmentForm = state.root.querySelector('[data-gpd-assignment-form]');
    var handoffForm = state.root.querySelector('[data-gpd-handoff-form]');
    var collaborationSave = state.root.querySelector('[data-gpd-collaboration-save]');
    if (assignmentForm) assignmentForm.hidden = !hasPermission(state, 'assign_opportunity');
    if (handoffForm) handoffForm.hidden = !hasPermission(state, 'manage_handoff');
    if (collaborationSave) collaborationSave.hidden = !hasPermission(state, 'edit_evidence');
  }

  // Dormant legacy loader. Keep disconnected until native Partner authorization is verified.
  // eslint-disable-next-line no-unused-vars -- Intentionally retained; resolveAccess remains fail-closed.
  async function loadWorkspace(state) {
    setWorkspaceStatus(state, words(state, 'loading'));
    var root = state.root;
    var results = await Promise.all([
      requestJson(endpoint(root, 'data-partner-organisation-endpoint')),
      requestJson(endpoint(root, 'data-partner-team-endpoint')),
      requestJson(endpoint(root, 'data-partner-assignments-endpoint')),
      requestJson(endpoint(root, 'data-partner-handoffs-endpoint')),
    ]);
    if (!state.active) return;
    state.organisation = results[0].ok ? dataOf(results[0].payload) : {};
    state.team = results[1].ok ? itemsOf(results[1].payload) : [];
    state.assignments = results[2].ok ? itemsOf(results[2].payload) : [];
    state.handoffs = results[3].ok ? itemsOf(results[3].payload) : [];
    renderOrganisation(state);
    renderTeam(state);
    renderAssignments(state);
    renderHandoffs(state);
    updateActionVisibility(state);
    setStat(root, 'team', state.team.length);
    setStat(root, 'assignments', state.assignments.length);
    setStat(root, 'handoffs', state.handoffs.length);
    setWorkspaceStatus(
      state,
      results.every(function (result) {
        return result.ok;
      })
        ? words(state, 'ready')
        : words(state, 'loadFailed')
    );
    root.setAttribute(
      'data-gpd-workspace-state',
      results.every(function (result) {
        return result.ok;
      })
        ? 'ready'
        : 'partial'
    );
  }

  async function resolveAccess(state) {
    const sequence = ++state.sequence;
    state.access = {};
    showAccess(state, 'loading');

    const session = window.LittleGWebSession;
    if (!session || typeof session.ready !== 'function') {
      showAccess(state, 'denied', words(state, 'unavailable'));
      return;
    }

    try {
      await session.ready();
      if (!state.active || sequence !== state.sequence) return;

      const current = session.getState();
      const status = clean(current && current.status);
      state.root.setAttribute('data-identity-state', status);

      if (status === 'guest' || status === 'anonymous') {
        showAccess(state, 'guest');
        return;
      }

      // Authentication is not Partner authorization. No legacy private API calls.
      showAccess(
        state,
        'denied',
        status === 'authenticated'
          ? locale(state) === 'zh'
            ? '合作方工作區暫未開放。登入不代表已獲批准。'
            : 'Partner access is not connected yet. Signing in does not grant approval.'
          : words(state, 'unavailable')
      );

      state.root.setAttribute('data-gpd-workspace-state', 'authorization-unverified');
    } catch (_) {
      if (state.active && sequence === state.sequence) {
        showAccess(state, 'denied', words(state, 'unavailable'));
      }
    }
  }

  async function submitAssignment(state, event) {
    event.preventDefault();
    var form = event.currentTarget;
    if (!form.reportValidity()) return;
    var data = new FormData(form);
    var note = state.root.querySelector('[data-gpd-assignment-note]');
    if (note) note.textContent = words(state, 'loading');
    var result = await requestJson(endpoint(state.root, 'data-partner-assignments-endpoint'), {
      method: 'POST',
      body: {
        tender_id: clean(data.get('tender_id')),
        assignee_customer_id: clean(data.get('assignee_customer_id')),
      },
    });
    if (note)
      note.textContent = result.ok
        ? words(state, 'assigned')
        : result.error || words(state, 'requestFailed');
    if (result.ok) {
      var listResult = await requestJson(endpoint(state.root, 'data-partner-assignments-endpoint'));
      if (listResult.ok) {
        state.assignments = itemsOf(listResult.payload);
        renderAssignments(state);
        setStat(state.root, 'assignments', state.assignments.length);
      }
    }
  }

  async function submitHandoff(state, event) {
    event.preventDefault();
    var form = event.currentTarget;
    if (!form.reportValidity()) return;
    var data = new FormData(form);
    var note = state.root.querySelector('[data-gpd-handoff-note]');
    if (note) note.textContent = words(state, 'loading');
    var result = await requestJson(endpoint(state.root, 'data-partner-handoffs-endpoint'), {
      method: 'POST',
      body: {
        tender_id: clean(data.get('tender_id')),
        client_reference: clean(data.get('client_reference')),
        client_name: clean(data.get('client_name')),
        project_ref: clean(data.get('project_ref')),
        service_scope: clean(data.get('service_scope')),
      },
    });
    if (note)
      note.textContent = result.ok
        ? words(state, 'handoffCreated')
        : result.error || words(state, 'requestFailed');
    if (result.ok) {
      var listResult = await requestJson(endpoint(state.root, 'data-partner-handoffs-endpoint'));
      if (listResult.ok) {
        state.handoffs = itemsOf(listResult.payload);
        renderHandoffs(state);
        setStat(state.root, 'handoffs', state.handoffs.length);
      }
    }
  }

  function collaborationUrl(state, tenderId) {
    var raw = endpoint(state.root, 'data-partner-collaboration-endpoint');
    if (!raw) return '';
    var url = new URL(raw);
    url.searchParams.set('tender_id', tenderId);
    return url.toString();
  }

  function renderCollaboration(state, payload) {
    var target = state.root.querySelector('[data-gpd-collaboration-result]');
    if (!target) return;
    target.replaceChildren();
    var data = dataOf(payload);
    var collaboration =
      data.collaboration && typeof data.collaboration === 'object' ? data.collaboration : null;
    if (!collaboration) {
      target.appendChild(element('div', 'gpd-empty', words(state, 'collaborationEmpty')));
      target.hidden = false;
      return;
    }
    var row = element('article', 'gpd-row');
    row.appendChild(
      element(
        'strong',
        '',
        clean(data.tender && (data.tender.title || data.tender.tender_reference)) ||
          clean(collaboration.tender_id) ||
          'Opportunity'
      )
    );
    var meta = element('div', 'gpd-row-meta');
    meta.appendChild(
      element('span', '', words(state, 'stage') + ': ' + clean(collaboration.stage))
    );
    if (clean(collaboration.project_ref))
      meta.appendChild(
        element('span', '', words(state, 'project') + ': ' + clean(collaboration.project_ref))
      );
    meta.appendChild(
      element(
        'span',
        '',
        words(state, 'evidence') +
          ': ' +
          String(Array.isArray(data.evidence) ? data.evidence.length : 0)
      )
    );
    meta.appendChild(
      element(
        'span',
        '',
        words(state, 'assignments') +
          ': ' +
          String(Array.isArray(data.assignments) ? data.assignments.length : 0)
      )
    );
    row.appendChild(meta);
    if (clean(collaboration.shared_note))
      row.appendChild(element('p', '', clean(collaboration.shared_note)));
    target.appendChild(row);
    target.hidden = false;

    var form = state.root.querySelector('[data-gpd-collaboration-form]');
    if (form) {
      if (form.elements.stage) form.elements.stage.value = clean(collaboration.stage) || 'watching';
      if (form.elements.project_ref)
        form.elements.project_ref.value = clean(collaboration.project_ref);
      if (form.elements.shared_note)
        form.elements.shared_note.value = clean(collaboration.shared_note);
    }
  }

  async function loadCollaboration(state) {
    var form = state.root.querySelector('[data-gpd-collaboration-form]');
    var note = state.root.querySelector('[data-gpd-collaboration-note]');
    if (!form || !form.reportValidity()) return;
    var tenderId = clean(form.elements.tender_id && form.elements.tender_id.value);
    if (note) note.textContent = words(state, 'loading');
    var result = await requestJson(collaborationUrl(state, tenderId));
    if (note)
      note.textContent = result.ok
        ? words(state, 'collaborationLoaded')
        : result.status === 404
          ? words(state, 'collaborationEmpty')
          : result.error || words(state, 'requestFailed');
    if (result.ok) renderCollaboration(state, result.payload);
    else {
      var target = state.root.querySelector('[data-gpd-collaboration-result]');
      if (target) {
        target.replaceChildren(
          element(
            'div',
            'gpd-empty',
            result.status === 404
              ? words(state, 'collaborationEmpty')
              : result.error || words(state, 'requestFailed')
          )
        );
        target.hidden = false;
      }
    }
  }

  async function saveCollaboration(state, event) {
    event.preventDefault();
    var form = event.currentTarget;
    if (!form.reportValidity()) return;
    var data = new FormData(form);
    var note = state.root.querySelector('[data-gpd-collaboration-note]');
    if (note) note.textContent = words(state, 'loading');
    var result = await requestJson(endpoint(state.root, 'data-partner-collaboration-endpoint'), {
      method: 'POST',
      body: {
        tender_id: clean(data.get('tender_id')),
        stage: clean(data.get('stage')) || 'watching',
        project_ref: clean(data.get('project_ref')),
        shared_note: clean(data.get('shared_note')),
      },
    });
    if (note)
      note.textContent = result.ok
        ? words(state, 'saved')
        : result.error || words(state, 'requestFailed');
    if (result.ok) renderCollaboration(state, result.payload);
  }

  function bind(state) {
    var retry = state.root.querySelector('[data-gpd-retry]');
    var assignmentForm = state.root.querySelector('[data-gpd-assignment-form]');
    var handoffForm = state.root.querySelector('[data-gpd-handoff-form]');
    var collaborationForm = state.root.querySelector('[data-gpd-collaboration-form]');
    var collaborationLoad = state.root.querySelector('[data-gpd-collaboration-load]');
    if (retry)
      retry.addEventListener(
        'click',
        function () {
          resolveAccess(state);
        },
        { signal: state.controller.signal }
      );
    if (assignmentForm)
      assignmentForm.addEventListener(
        'submit',
        function (event) {
          submitAssignment(state, event);
        },
        { signal: state.controller.signal }
      );
    if (handoffForm)
      handoffForm.addEventListener(
        'submit',
        function (event) {
          submitHandoff(state, event);
        },
        { signal: state.controller.signal }
      );
    if (collaborationForm)
      collaborationForm.addEventListener(
        'submit',
        function (event) {
          saveCollaboration(state, event);
        },
        { signal: state.controller.signal }
      );
    if (collaborationLoad)
      collaborationLoad.addEventListener(
        'click',
        function () {
          loadCollaboration(state);
        },
        { signal: state.controller.signal }
      );
    document.addEventListener(
      'gcity:auth:ready',
      function () {
        resolveAccess(state);
      },
      { signal: state.controller.signal }
    );
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var state = {
      root: root,
      active: true,
      sequence: 0,
      controller: new AbortController(),
      access: {},
      organisation: {},
      team: [],
      assignments: [],
      handoffs: [],
    };
    stateByRoot.set(root, state);
    root.setAttribute('data-gpd-runtime-version', VERSION);
    bind(state);
    resolveAccess(state);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    state.sequence += 1;
    state.controller.abort();
    stateByRoot.delete(root);
    root.removeAttribute('data-gpd-runtime-version');
    root.removeAttribute('data-gpd-browser-role');
    root.setAttribute('data-gpd-access', 'loading');
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    list(target, ROOT_SELECTOR).forEach(mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    list(target, ROOT_SELECTOR).forEach(destroy);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target || document);
  });
  window[GLOBAL_KEY] = Object.freeze({ version: VERSION, boot: boot, destroy: destroyAll });

  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  else boot(document);
})(window, document);
